module.exports = __webpack_public_path__ + "img/remainder3.461959f4.svg";